<div class="minor-account-repeat">
  @if (!ready) {
    <div>
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
  }
  @if (ready) {
    @if (error) {
      <se-fe-alert
        seFeDataType="critical"
        [seFeDismissible]="true"
        (seFeDismiss)="dismissError()">
        Oops! Something went wrong.
      </se-fe-alert>
    }
    <div class="minor-account-repeat-icon">
      <se-fe-icon
        seFeDataName="spot_sand_clock"
        seFeDataSize="950"
        seFeDataAriaLabel="hourglass"
        [seFeDataMargin]="false"
      ></se-fe-icon>
    </div>
    <div class="minor-account-repeat-title">
      <se-po-highlight-label
        label="Account Transfer Pending"
      ></se-po-highlight-label>
    </div>
    <div class="minor-account-invite-body">
      <p>
        You're part's all done.
        Now it's your parent's turn to accept your invitation
        and finish transferring your account.
      </p>
      <p>
        Once your parent has finished the account transfer process
        your profile will be accessible from their account.
      </p>
      <div class="minor-account-repeat-resend">
        <se-fe-chip
          seFeDataText="Pending"
          [seFeDataLoading]="submitting"
          [seFeMenuTrigger]="minorAccountMenu">
          {{ toEmailAddress }}
        </se-fe-chip>
        <se-fe-menu #minorAccountMenu [seFeDataOptions]="menuOptions"></se-fe-menu>
      </div>
    </div>
  }
</div>
